import { render, staticRenderFns } from "./CardCustomizationBulkImport.vue?vue&type=template&id=23a4be4c&scoped=true"
import script from "./CardCustomizationBulkImport.vue?vue&type=script&lang=ts"
export * from "./CardCustomizationBulkImport.vue?vue&type=script&lang=ts"
import style0 from "./CardCustomizationBulkImport.vue?vue&type=style&index=0&id=23a4be4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a4be4c",
  null
  
)

export default component.exports